


  
  

  var faLightBoxCircleArrowRight = {
    prefix: 'fak',
    iconName: 'light-box-circle-arrow-right',
    icon: [
      640,
      512,
      [],
      'e000',
      
      'M0 189.6c0-9 1.9-17.8 5.5-26L47.1 70c10.3-23.1 33.2-38 58.5-38l236.8 0c25.3 0 48.2 14.9 58.5 38l41.6 93.6c3.6 8.2 5.5 17 5.5 26l0 9c-11.2 3.2-21.9 7.4-32 12.6l0-19.2-176 0-32 0L32 192l0 224c0 17.7 14.3 32 32 32l275.2 0c5.9 11.4 12.9 22.2 21.1 32L64 480c-35.3 0-64-28.7-64-64L0 189.6zM42.1 160L208 160l0-96L105.6 64C93 64 81.5 71.4 76.4 83L42.1 160zM240 64l0 96 165.9 0L371.7 83c-5.1-11.6-16.6-19-29.2-19l-.1 0L240 64zM352 368c0-79.5 64.5-144 144-144s144 64.5 144 144s-64.5 144-144 144s-144-64.5-144-144zm32 0c0 61.9 50.1 112 112 112s112-50.1 112-112s-50.1-112-112-112s-112 50.1-112 112zm32 0c0-8.8 7.2-16 16-16l89.4 0-28.7-28.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l56 56c6.2 6.2 6.2 16.4 0 22.6l-56 56c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L521.4 384 432 384c-8.8 0-16-7.2-16-16z'
      
    ]
  };

  

  
  

  var faLightBoxCircleXmark = {
    prefix: 'fak',
    iconName: 'light-box-circle-xmark',
    icon: [
      640,
      512,
      [],
      'e003',
      
      'M0 189.6c0-9 1.9-17.8 5.5-26L47.1 70c10.3-23.1 33.2-38 58.5-38l236.8 0c25.3 0 48.2 14.9 58.5 38l41.6 93.6c3.6 8.2 5.5 17 5.5 26l0 9c-11.2 3.2-21.9 7.4-32 12.6l0-19.2-176 0-32 0L32 192l0 224c0 17.7 14.3 32 32 32l275.2 0c5.9 11.4 12.9 22.2 21.1 32L64 480c-35.3 0-64-28.7-64-64L0 189.6zM42.1 160L208 160l0-96L105.6 64C93 64 81.5 71.4 76.4 83L42.1 160zM240 64l0 96 165.9 0L371.7 83c-5.1-11.6-16.6-19-29.2-19l-.1 0L240 64zM352 368c0-79.5 64.5-144 144-144s144 64.5 144 144s-64.5 144-144 144s-144-64.5-144-144zm32 0c0 61.9 50.1 112 112 112s112-50.1 112-112s-50.1-112-112-112s-112 50.1-112 112zm52.7-59.3c6.2-6.2 16.4-6.2 22.6 0L496 345.4l36.7-36.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L518.6 368l36.7 36.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L496 390.6l-36.7 36.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L473.4 368l-36.7-36.7c-6.2-6.2-6.2-16.4 0-22.6z'
      
    ]
  };

  

  
  

  var faLightWarehouseCircleArrowLeft = {
    prefix: 'fak',
    iconName: 'light-warehouse-circle-arrow-left',
    icon: [
      640,
      512,
      [],
      'e002',
      
      'M0 175.9c0-25.8 15.4-49 39.2-59L301.4 6.5c11.9-5 25.3-5 37.3 0L600.8 116.9c23.7 10 39.2 33.2 39.2 59l0 90.9c-9.1-12.9-19.9-24.5-32-34.5l0-56.4c0-12.9-7.7-24.5-19.6-29.5L326.2 36c-4-1.7-8.4-1.7-12.4 0L51.6 146.4C39.7 151.4 32 163 32 175.9L32 496c0 8.8-7.2 16-16 16s-16-7.2-16-16L0 175.9zM96 224c0-17.7 14.3-32 32-32l368 0c-37.7 0-72.6 11.8-101.2 32L128 224l0 64 211.2 0c-5.2 10.1-9.4 20.8-12.6 32L128 320l0 64 192.7 0c1 11 3 21.7 5.9 32L128 416l0 64 232.3 0c10 12.1 21.6 22.9 34.5 32l-282.6 0-.2 0c-8.8 0-16-7.2-16-16l0-272zM352 368.1c0-51.4 27.4-99 72-124.7s99.4-25.7 144 0s72 73.3 72 124.7s-27.4 99-72 124.7s-99.4 25.7-144 0s-72-73.3-72-124.7zm32 0c0 40 21.3 77 56 97s77.3 20 112 0s56-57 56-97s-21.3-77-56-97s-77.3-20-112 0s-56 57-56 97zm36.7-11.4l56-56c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L470.6 352l89.4 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-89.4 0 28.7 28.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 .1l-56-56c-6.3-6.3-6.3-16.4 0-22.7zM496 192l16 0c4.1 0 8 .8 11.6 2.2c-9-1.4-18.2-2.2-27.6-2.2z'
      
    ]
  };

  

  
  

  var faLightWarehouseCircleArrowRight = {
    prefix: 'fak',
    iconName: 'light-warehouse-circle-arrow-right',
    icon: [
      640,
      512,
      [],
      'e001',
      
      'M0 175.9c0-25.8 15.4-49 39.2-59L301.4 6.5c11.9-5 25.3-5 37.3 0L600.8 116.9c23.7 10 39.2 33.2 39.2 59l0 90.9c-9.1-12.9-19.9-24.5-32-34.5l0-56.4c0-12.9-7.7-24.5-19.6-29.5L326.2 36c-4-1.7-8.4-1.7-12.4 0L51.6 146.4C39.7 151.4 32 163 32 175.9L32 496c0 8.8-7.2 16-16 16s-16-7.2-16-16L0 175.9zM96 224c0-17.7 14.3-32 32-32l368 0c-37.7 0-72.6 11.8-101.2 32L128 224l0 64 211.2 0c-5.2 10.1-9.4 20.8-12.6 32L128 320l0 64 192.7 0c1 11 3 21.7 5.9 32L128 416l0 64 232.3 0c10 12.1 21.6 22.9 34.5 32l-282.6 0-.2 0c-8.8 0-16-7.2-16-16l0-272zM352 368c0-79.5 64.5-144 144-144s144 64.5 144 144s-64.5 144-144 144s-144-64.5-144-144zm32 0c0 61.9 50.1 112 112 112s112-50.1 112-112s-50.1-112-112-112s-112 50.1-112 112zm32 0c0-8.8 7.2-16 16-16l89.4 0-28.7-28.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l56 56c6.2 6.2 6.2 16.4 0 22.6l-56 56c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L521.4 384 432 384c-8.8 0-16-7.2-16-16zm80-176l16 0c4.1 0 8 .8 11.6 2.2c-9-1.4-18.2-2.2-27.6-2.2z'
      
    ]
  };

  

  
  

  var faSolidBoxCircleExclamation = {
    prefix: 'fak',
    iconName: 'solid-box-circle-exclamation',
    icon: [
      640,
      512,
      [],
      'e006',
      
      'M0 160L50.7 58.5C58.9 42.3 75.5 32 93.7 32L208 32l0 128L0 160zm0 32l448 0 0 6.6C374.1 219.5 320 287.4 320 368c0 42.5 15.1 81.6 40.3 112L64 480c-35.3 0-64-28.7-64-64L0 192zM240 32l114.3 0c18.2 0 34.8 10.3 43 26.5L448 160l-208 0 0-128zM352 368c0-79.5 64.5-144 144-144s144 64.5 144 144s-64.5 144-144 144s-144-64.5-144-144zm120 72c0 13.3 10.7 24 24 24s24-10.7 24-24s-10.7-24-24-24s-24 10.7-24 24zm8-152l0 80c0 8.8 7.2 16 16 16s16-7.2 16-16l0-80c0-8.8-7.2-16-16-16s-16 7.2-16 16z'
      
    ]
  };

  

  
  

  var faSolidBoxSlash = {
    prefix: 'fak',
    iconName: 'solid-box-slash',
    icon: [
      640,
      512,
      [],
      'e004',
      
      'M5.1 9.2C13.3-1.2 28.4-3.1 38.8 5.1l96.7 75.8 11.2-22.4c8.2-16.2 24.8-26.5 43-26.5L304 32l0 128-67.6 0 40.8 32L544 192l0 209.1 86.8 68c10.4 8.2 12.3 23.3 4.1 33.7s-23.3 12.3-33.7 4.1L9.2 42.9C-1.2 34.7-3.1 19.6 5.1 9.2zM96 192l25.8 0L486.9 479.6c-2.3 .2-4.6 .4-6.9 .4l-320 0c-35.3 0-64-28.7-64-64l0-224zM336 32l114.3 0c18.2 0 34.8 10.3 43 26.5L544 160l-208 0 0-128z'
      
    ]
  };

  

  
  

  var faSolidPalletBoxesCircleExclamation = {
    prefix: 'fak',
    iconName: 'solid-pallet-boxes-circle-exclamation',
    icon: [
      640,
      512,
      [],
      'e007',
      
      'M0 352c0 17.7 14.3 32 32 32l32 0 0 64-32 0c-17.7 0-32 14.3-32 32s14.3 32 32 32l64 0 224 0 74.8 0C349.6 480.1 320 427.5 320 368c0-16.6 2.3-32.7 6.6-48l-6.6 0L96 320l-64 0c-17.7 0-32 14.3-32 32zM64 32l0 192c0 17.7 14.3 32 32 32l192 0c17.7 0 32-14.3 32-32l0-192c0-17.7-14.3-32-32-32L96 0C78.3 0 64 14.3 64 32zm64 352l160 0 0 64-160 0 0-64zm224-16c0 79.5 64.5 144 144 144s144-64.5 144-144s-64.5-144-144-144s-144 64.5-144 144zM384 96l0 128c0 2.6 .3 5.1 .9 7.5c30.3-24.7 69-39.5 111.1-39.5c28.8 0 56 6.9 80 19.2L576 96c0-17.7-14.3-32-32-32L416 64c-17.7 0-32 14.3-32 32zm88 344c0-13.3 10.7-24 24-24s24 10.7 24 24s-10.7 24-24 24s-24-10.7-24-24zm8-152c0-8.8 7.2-16 16-16s16 7.2 16 16l0 80c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-80z'
      
    ]
  };

  

  
  

  var faSolidTruckClockSlash = {
    prefix: 'fak',
    iconName: 'solid-truck-clock-slash',
    icon: [
      640,
      512,
      [],
      'e005',
      
      'M0 96l96.1 75.7c-.1 1.4-.1 2.9-.1 4.3c0 40 21.3 77 56 97c26.5 15.3 57.7 18.9 86.4 10.8l201.8 159c4 6 9.4 11 15.8 14.8c2.3 1.3 4.8 2.5 7.2 3.4L518 504.2c-11.7 5-24.5 7.8-38 7.8c-53 0-96-43-96-96l-128 0c0 53-43 96-96 96s-96-43-96-96l-16 0c-26.5 0-48-21.5-48-48L0 96zM5.1 9.2c7-8.9 19-11.5 28.8-7.1C38.4 .7 43.1 0 48 0L368 0c26.5 0 48 21.5 48 48l0 48 50.7 0c17 0 33.3 6.7 45.3 18.7L589.3 192c12 12 18.7 28.3 18.7 45.3l0 18.7 0 32 0 64c17.7 0 32 14.3 32 32s-14.3 32-32 32l-32 0c0 3.3-.2 6.6-.5 9.8l55.3 43.3c10.4 8.2 12.3 23.3 4.1 33.7s-23.3 12.3-33.7 4.1L9.2 42.9C-1.2 34.7-3.1 19.6 5.1 9.2zM118.4 392c-8.6 14.9-8.6 33.1 0 48s24.4 24 41.6 24s33-9.1 41.6-24s8.6-33.1 0-48s-24.4-24-41.6-24s-33 9.1-41.6 24zM141.7 85.7L192 125.2l0-13.2c0-8.8 7.2-16 16-16s16 7.2 16 16l0 38.3 12.4 9.7 3.6 0c8.6 0 15.6 6.8 16 15.3l55.5 43.5c5.5-13.4 8.5-27.9 8.5-42.8c0-40-21.3-77-56-97s-77.3-20-112 0c-3.6 2.1-7 4.3-10.3 6.7zM416 160l0 96 128 0 0-18.7L466.7 160 416 160z'
      
    ]
  };

  

  
  

  var faSolidTruckMovingSlash = {
    prefix: 'fak',
    iconName: 'solid-truck-moving-slash',
    icon: [
      640,
      512,
      [],
      'e008',
      
      'M0 96c121.8 96 243.7 192 365.5 288l-79.1 0c1 5.2 1.6 10.5 1.6 16c0 44.2-35.8 80-80 80c-26.2 0-49.4-12.6-64-32c-14.6 19.4-37.8 32-64 32c-44.2 0-80-35.8-80-80l0-16 0-80L0 96zM5.1 9.2C13.3-1.2 28.4-3.1 38.8 5.1L73.1 32 416 32c35.3 0 64 28.7 64 64l0 48.1 48.9 0c16.8 0 32.7 7.5 43.3 20.5L631 236.4c5.8 7.1 9 16.1 9 25.3l0 10.3 0 16 0 64c0 17.7-14.3 32-32 32l-1.6 0c1 5.2 1.6 10.5 1.6 16c0 15.4-4.3 29.7-11.9 41.9l34.7 27.2c10.4 8.2 12.3 23.3 4.1 33.7s-23.3 12.3-33.7 4.1L9.2 42.9C-1.2 34.7-3.1 19.6 5.1 9.2zM48 400c0 17.7 14.3 32 32 32s32-14.3 32-32s-14.3-32-32-32s-32 14.3-32 32zm128 0c0 17.7 14.3 32 32 32s32-14.3 32-32s-14.3-32-32-32s-32 14.3-32 32zM480 192l0 64 105 0-50-61.1c-1.5-1.8-3.8-2.9-6.2-2.9L480 192zm29.4 182l48.3 37.9c1.5-3.7 2.3-7.7 2.3-11.8c0-17.7-14.3-32-32-32c-6.9 0-13.4 2.2-18.6 6z'
      
    ]
  };

  



export {

  faLightBoxCircleArrowRight,
  

  faLightBoxCircleXmark,
  

  faLightWarehouseCircleArrowLeft,
  

  faLightWarehouseCircleArrowRight,
  

  faSolidBoxCircleExclamation,
  

  faSolidBoxSlash,
  

  faSolidPalletBoxesCircleExclamation,
  

  faSolidTruckClockSlash,
  

  faSolidTruckMovingSlash,
  

};
